
import { Component, Vue } from "vue-property-decorator";
import NotificationTemplateSetup from "@/components/notification-templates/NotificationTemplateSetup.vue";
import NotificationBrandingTemplateSetup from "@/components/notification-templates/NotificationBrandingTemplateSetup.vue";
import IntegrationTemplateSetup from '@/components/notification-templates/IntegrationTemplateSetup.vue';
import NotificationRuleSetup from "@/components/notification-templates/NotificationRuleSetup.vue";
import NavHeader from "@/components/NavHeader.vue";
import { Getter } from "vuex-class";
import { UserPermissions } from "@/store/types";
import NotificationTemplateSettings from "@/components/notification-templates/NotificationTemplateSettings.vue";

@Component({
    components: {
        "notification-template-setup": NotificationTemplateSetup,
        "notification-branding-template-setup": NotificationBrandingTemplateSetup,
        "integration-template-setup": IntegrationTemplateSetup,
        "notification-rule-setup": NotificationRuleSetup,
        "nav-header": NavHeader,
		"notification-template-settings": NotificationTemplateSettings
    },
})
export default class NotificationsSetup extends Vue {
    @Getter("getPermissions") private permissions: UserPermissions;
    @Getter("getFeature") getFeature: (featureName: string[]) => boolean;

	private get isNotificationTemplatesEnabled(): boolean {
		return this.getFeature(["Alarms", "SiteMonitor", "Email", "NotificationTemplates"]);
	}

	private get hasNotificationTemplatePermissions(): boolean {
		return this.permissions.canViewNotificationTemplates || this.permissions.canEditNotificationTemplates;
	}

    private get hasNotificationTemplateAccess(): boolean {
        return this.isNotificationTemplatesEnabled && this.hasNotificationTemplatePermissions;
    }

    private get isIntegrationTemplatesEnabled(): boolean {
        return this.getFeature(["Actions", "MassNotification"]);
    }

    private get hasIntegrationTemplatePermissions(): boolean {
        return this.permissions.canViewIntegrationTemplates || this.permissions.canEditIntegrationTemplates;
    }

    private get hasIntegrationTemplateAccess(): boolean {
        return this.isIntegrationTemplatesEnabled && this.hasIntegrationTemplatePermissions;
    }

	private get isNotificationRulesEnabled(): boolean {
		return this.getFeature(["Alarms", "SiteMonitor", "Email", "NotificationTemplates", "NotificationRules"]);
	}

	private get hasNotificationRulePermissions(): boolean {
		return this.permissions.canViewNotificationRules || this.permissions.canEditNotificationRules;
	}

    private get hasRulesAccess(): boolean {
        return this.isNotificationRulesEnabled && this.hasNotificationRulePermissions;
    }

    private get canViewPage(): boolean {
        return this.hasNotificationTemplateAccess || this.hasRulesAccess || this.hasIntegrationTemplateAccess;
    }

    private get isNotificationBrandingTemplatesEnabled(): boolean {
       return this.getFeature(["Alarms", "SiteMonitor", "Email", "NotificationTemplates", "BrandingTemplates"]);
    }

	private get isNotificationSettingsEnabled(): boolean {
		return !!this.getFeature(["Alarms", "SiteMonitor", "Email", "NotificationTemplates", "SettingsTab"]);
	}

	private get hasEditSiteSetupPermission(): boolean {
		return this.permissions.canEditSiteSetup;
	}
}
